const baseUrl = "https://mom-backend.onrender.com";
//const baseUrl = "http://localhost:3002";

export default baseUrl;